import React from 'react';

const SecondaryScoreCardContent = ({result, heading}) => {
    let image;
    let description;

    if (result.imageUrl && result.imageUrl !== '') {
        image = (
            <div className="img-container">
                <img className="result-img" src={result.imageUrl} alt="" />
            </div>
        );
    }

    if (result.secondaryDescription && result.secondaryDescription !== '') {
        description = (
            <div
                className="description"
                dangerouslySetInnerHTML={{__html: result.secondaryDescription}}
            />
        );
    }

    return (
        <>
            {heading && (<h3 className="result-card-heading">{heading}</h3>)}
            <div className="result-card secondary">
                <div className="result-card-content">
                    <h1 className="title">{result.title}</h1>

                    {description}
                </div>
                {image}
            </div>
        </>
    );
};

export default SecondaryScoreCardContent;
